module.exports = __webpack_public_path__ + "static/media/PROCEPT_Logo_Solid_RGB_150.5d7b1276.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PROCEPT_Logo_Solid_RGB_150.png
// module id = 1377
// module chunks = 0